import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCateringEventFormatBySlugApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            description: z.any(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
            category: z.object({
                documentId: z.string(),
                name: z.string(),
                slug: z.string(),
            }).optional().nullable(),
            slug: z.string(),
        }),
    ),
});

type GetCateringEventFormatBySlugActionResponse
    = ApiResponse<z.infer<typeof GetCateringEventFormatBySlugApiResponseSchema>>
    | BaseError;

type GetCateringEventFormatBySlugActionRequest = {
    slug: string,
}

export const getCateringEventFormatBySlug = createAsyncThunk<
    GetCateringEventFormatBySlugActionResponse,
    GetCateringEventFormatBySlugActionRequest
>(
    'CateringEventFormatActionsGetCateringEventFormatBySlug',
    async ({
        slug,
    }) => apiInstance.get(
        '/catering-event-formats',
        {
            'filters[slug][$eq]': slug,
            'populate[image][fields]': 'url',
            'populate[category][fields]': '*',
        },
        GetCateringEventFormatBySlugApiResponseSchema,
    ),
);
